import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ManageCancelReason.css';
import cx from 'classnames';
import getAllCancelReason from './getAllCancelReason.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import CancellationReasonList from '../../../components/SiteAdmin/CancellationReason/CancellationReasonList'
import Loader from '../../../components/Common/Loader/Loader';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

export class ManageCancelReason extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired
    }

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { cancelReasons, cancelReasons: { loading, getAllCancelReason } } = this.props;
        
        return (
            <Loader type={"page"} show={loading}>
            <div className={s.root}>
                <div className={s.container}>
                   <div className={cx(s.heading, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.cancelReason} />
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <CancellationReasonList cancelReasons={cancelReasons} />
                    </div>
                </div>
            </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getAllCancelReason, {
        name: 'cancelReasons',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only'
        }
    })
)(ManageCancelReason);
